// extracted by mini-css-extract-plugin
module.exports = {"login-page":"styles_login-page__15k55","content":"styles_content__2o3Ur","body":"styles_body__3B6wT","migration":"styles_migration__3Y7Av"};